module.exports = "<dt-content-header state-title=\"'Folders & Labels'\"></dt-content-header> <dt-tabs flex tabs=$ctrl.tabs on-tab-click=$ctrl.onTabClickProxy($event)></dt-tabs> <div ui-view=contentBody></div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/folders-and-labels/folders-and-labels.html
// module id = joEl
// module chunks = 1